export default {
    current_choice: 'Trenutni odabir',
    book_now: 'Rezerviraj sada',
    minimum_age: 'Samo za osobe starije od {age} godina',
    excess_liability: 'Višak odgovornosti',
    security_deposit: 'Sigurnosni depozit',
    fuel_policy: 'Pravila goriva',
    like_for_like: 'Isto za isto',
    full_to_full: 'Puno do punog',
    miles_per_rental: '{mileage} besplatnih milja po najmu',
    km_per_rental: '{mileage} besplatnih km po najmu',
    unlimited_mileage: 'Neograničene milje',
    unlimited_mileage_km: 'Neograničeni km',
    non_amendable: 'Nije moguće mijenjati',
    non_refundable: 'Nepovratno',
    free_cancellation_until: 'Besplatno otkazivanje do',
    basic_free_cancellation: 'Besplatno otkazivanje do 48 sati prije početka najma',
    cancellation_in_line_with: 'Otkazivanje u skladu s',
    tcs: 'Uvjeti i odredbe',
    free_extras_on_collection: 'Dva besplatna dodatka pri preuzimanju',
    glass_and_tyres_covered: 'Stakla i gume pokriveni',
    number_of_passengers: 'Broj putnika',
    number_of_bags: 'Broj torbi',
    fuel_type: 'Vrsta goriva',
    co2: 'CO2',
    aircon: 'Klima uređaj',
    transmission: 'Mjenjač',
    book_type: 'Rezerviraj {type}',
    debit_card_deposit: 'Prihvaća se depozit debitnom karticom',
    fast_track_included: 'Brza usluga uključena',
    view_all: 'Pogledaj sve',
};
